const COMMON_BARE_DOMAIN_SUFFIXES = [
  'com',
  'org',
  'net',
  'edu',
  'gov',
  'mil',
  'info',
  'biz',
  'io',
  'co',
  'us',
  'uk',
  'ca',
  'de',
  'fr',
  'jp',
  'au',
  'br',
  'in',
  'eu',
  'nl',
  'xyz',
  'site',
  'online',
  'shop',
  'store',
  'app',
  'dev',
  'ai'
]

const COMMON_BARE_DOMAIN_SUFFIX_PATTERN = COMMON_BARE_DOMAIN_SUFFIXES.join('|')

// URL path: match non-whitespace chars with up to two levels of balanced parens.
// Each iteration of the outer repetition consumes EITHER a complete paren group OR
// exactly one non-special character. This eliminates nested quantifiers entirely -
// the outer star never competes with an inner quantifier for the same characters.
// Paren group supports depth-2: (a(b)c) but not (a(b(c)d)e).
const URL_PATH_CHAR = String.raw`[^\s()<>[\]{}"'\u00ab\u00bb\u201c\u201d\u2018\u2019]`
const URL_PAREN_GROUP = String.raw`\([^\s()]*(?:\([^\s()]*\)[^\s()]*)*\)`
const URL_PATH = String.raw`(?:${URL_PAREN_GROUP}|${URL_PATH_CHAR})*`
const URL_PATH_END = String.raw`(?:${URL_PAREN_GROUP}|[^\s\`!()[\]{};:'".,<>?\u00ab\u00bb\u201c\u201d\u2018\u2019])`

export const URL_MATCH = new RegExp(
  String.raw`\b(?:https?:\/\/${URL_PATH}${URL_PATH_END})|(?<![@/\w-])(?:www\d{0,3}[.]${URL_PATH}${URL_PATH_END})|(?<![@/\w-])(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?[.])+(?:${COMMON_BARE_DOMAIN_SUFFIX_PATTERN})(?:\/${URL_PATH}${URL_PATH_END})?)(?![@\w-]|\.[a-z0-9])`,
  'gi'
)

export const SPECIAL_CHARACTERS_ONLY =
  /^[$&+,:;=?@#|'<>.^*(){}[\]%!/`~_"'\\-]+$/
